import { Principal } from '@dfinity/principal';
import { getAllUserNFTs } from '@psychedelic/dab-js';
import { useRecoilState, useSetRecoilState } from 'recoil';

import { initPlugState, myCollectionsState } from 'lib/recoil/atoms';

const windowObject = window as any;

// Canister Ids
const nnsCanisterId = 'iiibs-tqaaa-aaaak-aab6q-cai';

// Whitelist
const whitelist = [nnsCanisterId];

// Host
const host = 'https://mainnet.dfinity.network';

// If plug is installed
const isPlugWalletInstalled = !!windowObject.ic.plug;

export const useInitPlug = () => {
	const setCollections = useSetRecoilState(myCollectionsState);
	const [plugState, setPlugState] = useRecoilState(initPlugState);

	const connectWallet = async () => {
		if (!isPlugWalletInstalled) {
			return;
		}

		setPlugState(prevState => ({
			...prevState,
			isLoading: true
		}));

		try {
			await windowObject.ic.plug.requestConnect({
				whitelist,
				host
			});

			const connected = (await windowObject.ic.plug.isConnected()) as boolean;
			if (connected) {
				await windowObject.ic.plug.createAgent({ whitelist });

				// Get the user principal id
				const principalId = await windowObject.ic.plug.agent.getPrincipal();
				const principalIdToText = `${principalId}`;

				// Get all NFTs supported by Plug
				const collections = await getAllUserNFTs({
					user: Principal.fromText(principalIdToText)
				});

				setCollections(collections);
				setPlugState({
					principalId: principalIdToText,
					isConnected: connected,
					isLoading: false
				});
			}
		} catch (error) {
			console.log(error);

			setPlugState(prevState => ({
				...prevState,
				isLoading: false
			}));
		}
	};

	const onBuy = async (amount: number) => {
		try {
			if (isPlugWalletInstalled) {
				if (plugState.isConnected) {
					windowObject.ic.plug.requestTransfer({
						to: 'rszt5-dlas5-k7rk5-tdtb2-iqpsh-5tf7q-hfpoc-led3k-xgdqn-shcav-uae',
						amount
					});
				} else {
					const response = await windowObject.ic.plug.requestConnect({
						whitelist,
						host
					});

					if (response) {
						windowObject.ic.plug.requestTransfer({
							to: 'rszt5-dlas5-k7rk5-tdtb2-iqpsh-5tf7q-hfpoc-led3k-xgdqn-shcav-uae',
							amount
						});
					}
				}
			} else {
				alert('Install the Plug Wallet extention!');
			}
		} catch (error) {
			alert('something went wrong when initializing PLUG, do you have the extension installed?');
		}
	};

	return {
		connectWallet,
		onBuy
	};
};
